import { Link } from "react-router-dom";
import { Storefront } from "@phosphor-icons/react";
import { StarDisplay } from "@/components/reviews/StarRating";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const reviewPhotoUrl = (p) => `${BACKEND}/api/files/${p}`;

export default function ReviewCard({ review, showProduct = false, onPhoto }) {
  const date = new Date(review.created_at).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  return (
    <article data-testid={`review-${review.id}`} className="review-card border border-border bg-white rounded-sm p-6 flex flex-col gap-4">
      <div className="flex items-start justify-between gap-3">
        <StarDisplay value={review.rating} testId={`review-stars-${review.id}`} />
        <span className="text-xs text-muted-foreground">{date}</span>
      </div>
      {review.title && <h3 className="font-display text-lg leading-snug">{review.title}</h3>}
      <p className="text-sm text-foreground/85 leading-relaxed whitespace-pre-line">{review.text}</p>
      {review.photo_paths?.length > 0 && (
        <div className="flex gap-2">
          {review.photo_paths.map((p, i) => (
            <button key={p} type="button" data-testid={`review-photo-${review.id}-${i}`} onClick={() => onPhoto?.(p)}
              className="w-20 h-20 rounded-sm overflow-hidden border border-border hover:border-[#C84A31] transition-colors cursor-zoom-in">
              <img src={reviewPhotoUrl(p)} alt="Customer photo" loading="lazy" className="w-full h-full object-cover" />
            </button>
          ))}
        </div>
      )}
      <div className="mt-auto pt-4 border-t border-border flex items-center justify-between gap-3 text-xs">
        <span className="font-display text-sm">{review.name}</span>
        {showProduct && (
          <Link to={`/product/${review.product_id}`} data-testid={`review-product-link-${review.id}`}
            className="flex items-center gap-2 min-w-0 text-muted-foreground hover:text-[#C84A31] transition-colors">
            {review.product_image && <img src={review.product_image} alt="" className="w-8 h-8 rounded-sm object-cover border border-border" />}
            <span className="truncate max-w-[160px]">{review.product_title}</span>
          </Link>
        )}
      </div>
      {review.public_reply && (
        <div data-testid={`review-reply-${review.id}`} className="bg-[#2A4B3C]/5 border-l-2 border-[#2A4B3C] rounded-sm px-4 py-3">
          <div className="text-[10px] uppercase tracking-[0.2em] text-[#2A4B3C] flex items-center gap-1 mb-1">
            <Storefront size={12} weight="fill" /> Reply from Reel Funny Goods
          </div>
          <p className="text-sm text-foreground/80 leading-relaxed whitespace-pre-line">{review.public_reply}</p>
        </div>
      )}
    </article>
  );
}
